import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  mainTitle: {
    marginBottom: theme.spacing(4),
  },
  paper: {
    paddingTop: theme.spacing(8),
  },
  mainContainer: {
    maxWidth: 950,
  },
  footerWrapper: {
    marginTop: theme.spacing(8),
    padding: theme.spacing(4, 0, 7),
    backgroundColor: theme.palette.neutral.lightest,
  },
  footer: {
    maxWidth: 950,
    margin: theme.spacing(0, 'auto'),
  },
  weHelpYouText: {
    color: theme.palette.neutral.main,
    margin: theme.spacing(2.5, 0, 0.5),
  },
  supportLink: {
    position: 'relative',
    paddingLeft: theme.spacing(3.5),

    '& svg': {
      position: 'absolute',
      left: 0,
      width: theme.spacing(2.5),
      height: theme.spacing(2.5),
      color: theme.palette.primary.main,
    },

    '&::after': {
      left: theme.spacing(3.5),
    },

    '&:hover': {
      '&::after': {
        width: `calc(100% - ${theme.spacing(3.5)})`,
      },
    },
  },
}))

export default useStyles
